import { ChameleonRequest } from "@repo/chameleon-request";
import { getApiUrl } from "@repo/utils/get-api-url";

import { Suggestions } from "./types";

export async function getSuggestions({
  chameleonRequestInstance,
  store,
  lang,
  keyStoreDataversion,
  q,
  limit = 10,
}: {
  chameleonRequestInstance: ChameleonRequest;
  store: string;
  lang: string;
  keyStoreDataversion: string;
  q: string;
  limit?: number;
}) {
  const url = getApiUrl({
    path: "/product/search/v2/suggestions",
    searchParams: {
      store,
      lang,
      keyStoreDataversion,
      q,
      limit: limit.toString(),
    },
  });

  const data = await chameleonRequestInstance.get<Suggestions>(
    url,
    {
      headers: {
        "Content-Type": "application/json",
        "asos-c-store": store,
      },
    },
    {
      requestType: "SEARCH_SUGGESTIONS_API",
    },
  );

  return {
    data,
  };
}
